import { render, staticRenderFns } from "./CrudLink.vue?vue&type=template&id=c6b6297a&scoped=true&"
import script from "./CrudLink.vue?vue&type=script&lang=js&"
export * from "./CrudLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b6297a",
  null
  
)

export default component.exports